<template>
  <section>
    <b-modal width="1280px" :active.sync="isCardModalActive" :can-cancel="true">
      <div class="card" style="border-radius: 5px;" v-if="isCardModalActive">
        <header class="card-header">
          <div class="card-header-title edit-title-wrapper">
            <span class="edit-title">スケジュール作成</span>
          </div>
        </header>
        <div class="card-content scroll-box">
          <!-- イベント作成/候補日時設定 -->
          <template v-if="step===0">
            <div class="message">
              <b-tabs style="background: white;">
                <b-tab-item label="基本設定" class="tab-box disp-scroll">
                  <div class="tab-box-form">
                    <div class="tab-box-left">
                      <p style="text-align: left;">
                        <b>タイトル</b>
                      </p>
                    </div>
                    <div class="tab-box-right">
                      <b-input style="width: 100%;" placeholder="タイトルを入力" v-model="info.title" max-length="100"></b-input>
                    </div>
                  </div>
                  <div class="dot-line"></div>
                  <template v-if="isCreateFromDate">
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>日時</b>
                        </p>
                      </div>
                      <div class="tab-box-right" style="flex-direction: column;">
                        <div style="display: flex; flex-direction: row;">
                          <b-datetimepicker
                            rounded
                            v-model="info.start"
                            placeholder="開始日時"
                            icon="calendar-today"
                            horizontal-time-picker>
                          </b-datetimepicker>
                          <p style="display: flex; justify-content: center; align-items: center; margin: 0 8px;"> ～ </p>
                          <b-datetimepicker
                            rounded
                            v-model="info.end"
                            placeholder="終了日時"
                            icon="calendar-today"
                            horizontal-time-picker>
                          </b-datetimepicker>
                        </div>
                        <div v-if="info.calendarType == 'nolinkage'" style="display: flex; flex-direction: row; margin-top: 16px;">
                          繰り返し：
                          <b-switch size="is-small" v-model="isRepeat" @input="changeRepeatDate">
                          </b-switch>
                        </div>
                        <div v-if="isRepeat" style="display: flex; flex-direction: row; margin-top: 8px;">
                          <div style="display: flex; align-items: center;">
                            間隔：1
                            <select class="select is-small" style="margin: 0 4px;" v-model="repeatInterval" @change="changeRepeatInterval">
                              <option
                                v-for="(value, key) in {'day': '日', 'week': '週'}"
                                :key="key"
                                :value="key">
                                {{value}}
                              </option>
                            </select>
                            ごと
                          </div>
                          <div style="display: flex; flex-direction: row; align-items: center; margin-left: 16px">
                            終了日：
                            <b-datepicker
                              v-model="repeatEndDate"
                              size="is-small"
                              locale="ja-JP"
                              placeholder="繰り返し終了日"
                              trap-focus
                              :min-date="repeatMinDate"
                              :max-date="repeatMaxDate">
                            </b-datepicker>
                          </div>
                        </div>
                        <div v-if="isRepeat && repeatInterval == 'week'" style="display: flex; flex-direction: row; margin-top: 8px">
                          <b-checkbox
                            v-for="(value, key) in {'Sun': '日', 'Mon': '月', 'Tue': '火', 'Wed': '水', 'Thu': '木', 'Fri': '金', 'Sat': '土'}"
                            :key="key" :native-value="key" v-model="repeatWeekDay">
                            {{value}}
                          </b-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left" style="flex-wrap: wrap;">
                        <p style="text-align: left;">
                          <b>メモ</b>
                          <br>
                        <span style="text-align: left; color: #666; font-size: 12px;">日程調整をした日の予定に入れるメモ欄です。</span>
                        </p>
                      </div>
                      <div class="tab-box-right">
                        <textarea class="input textarea disp-scroll" v-model="info.description" maxlength="200"></textarea>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left" style="flex-wrap: wrap;">
                        <p style="text-align: left;">
                          <b>参加者</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">自分以外に参加者がいる場合、選択してください。</span>
                        </p>
                      </div>
                      <div class="tab-box-right" style="flex-wrap: wrap;">
                        <SelectMemberTable
                          :isCalendar="true"
                          :users = users
                          :selfUser="user"
                          :calendarSettings="calendarSettings"
                          :isSync="true"
                          :usersStatusAPI="usersStatusAPI"
                          @changeShowEventSelectMember="changeAttendees"
                          @changeShowEventSelfSelectMember="changeAttendeesSelf"
                          @createCalendarSettingsSelectMember="changeAttendeesFromNo"
                          style="height: 250px;"/>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p><b>予定時間</b></p>
                      </div>
                      <div class="tab-box-right">
                        <p style="display: flex; align-items: center;">
                          <b-numberinput style="width: 100px;" size="is-small" :editable="false" step="1" min="0" max="23" v-model="info.mtg_time_hour" controls-position="compact"></b-numberinput>
                          <span style="margin-left: 4px;">時間</span>
                        </p>
                        <p style="display: flex; align-items: center; margin-left: 16px;">
                          <b-numberinput style="width: 100px;" size="is-small" :editable="false" step="15" min="0" max="45" v-model="info.mtg_time_minute" controls-position="compact"></b-numberinput>
                          <span style="margin-left: 4px;">分</span>
                        </p>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p><b><!--設定しない曜日-->休日</b></p>
                      </div>
                      <div class="tab-box-right">
                        <b-checkbox v-for="(ch, idx) in weekdayList" :key="idx" v-model="info.holiday_list"
                          :native-value="idx">
                          {{ch}}
                        </b-checkbox>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p><b><!--設定しない曜日-->祝日</b></p>
                      </div>
                      <div class="tab-box-right">
                        <b-switch style="width: 100%;" size="is-small" v-model="info.public_holiday">
                        </b-switch>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p><b>調整可能時間帯</b></p>
                      </div>
                      <div class="tab-box-right">
                        <b-timepicker v-model="start" size="is-small" inline></b-timepicker>
                        <p style="font-size: 24px;margin-left:10px;margin-right:10px;"><b>-</b></p>
                        <b-timepicker v-model="end" size="is-small" inline></b-timepicker>
                      </div>
                    </div>
                    <!-- <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>日程調整開始日</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">現在から何日後か入力します</span>
                        </p>
                      </div>
                      <div class="tab-box-right">
                        <p style="display: flex; align-items: center;">
                          <b-numberinput size="is-small" style="width: 100px;" v-model="info.after" :editable="false" min="1" max="10" controls-position="compact"></b-numberinput>
                          <span style="margin-left: 4px;">日後</span>
                        </p>
                      </div>
                    </div> -->
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left" style="flex-wrap: wrap;">
                        <p><b>メモ</b></p>
                        <br>
                        <span style="text-align: left; color: #666; font-size: 12px;">日程調整をした日の予定に入れるメモ欄です。</span>
                      </div>
                      <div class="tab-box-right">
                        <textarea class="input textarea disp-scroll" v-model="info.memo" maxlength="200"></textarea>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left" style="flex-wrap: wrap;">
                        <p style="text-align: left;">
                          <b>必須参加者</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">最低1人以上お選びください</span>
                        </p>
                      </div>
                      <div class="tab-box-right" style="flex-wrap: wrap;">
                        <SelectMemberTable
                          :isCalendar="true"
                          :users = users 
                          :selfUser="user"
                          :calendarSettings="calendarSettings"
                          :default2="true"
                          :isSync="true"
                          :usersStatusAPI="usersStatusAPI"
                          @changeShowEventSelectMember="changeUserHash"
                          @changeShowEventSelfSelectMember="changeUserHashSelf"
                          @createCalendarSettingsSelectMember="changeUserHashFromNo"
                          style="height: 250px;"/>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left" style="flex-wrap: wrap;">
                        <p style="text-align: left;">
                          <b>任意参加者</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">選択した中から1人が選ばれます</span>
                        </p>
                      </div>
                      <div class="tab-box-right" style="flex-wrap: wrap;">
                        <SelectMemberTable
                          :isCalendar="true"
                          :users = users 
                          :selfUser="user"
                          :calendarSettings="calendarSettings"
                          :default2="false"
                          :isSync="true"
                          :usersStatusAPI="usersStatusAPI"
                          @changeShowEventSelectMember="changeUserHashSub"
                          @changeShowEventSelfSelectMember="changeUserHashSubSelf"
                          @createCalendarSettingsSelectMember="changeUserHashSubFromNo"
                          style="height: 250px;"/>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p><b>共有者</b></p>
                      </div>
                      <div class="tab-box-right" style="flex-wrap: wrap;">
                        <SelectMemberTable
                          :isCalendar="true"
                          :users = users 
                          :selfUser="user"
                          :calendarSettings="calendarSettings"
                          :default2="false"
                          :isSync="true"
                          :usersStatusAPI="usersStatusAPI"
                          @changeShowEventSelectMember="changeUserHashShare"
                          @changeShowEventSelfSelectMember="changeUserHashShareSelf"
                          @createCalendarSettingsSelectMember="changeUserHashShareFromNo"
                          style="height: 250px;"/>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left" style="flex-wrap: wrap;">
                        <p><b>候補確定方法</b></p>
                        <br>
                        <span style="text-align: left; color: #666; font-size: 12px;">候補を上げた際の確定方法をお選びください。</span>
                      </div>
                      <div class="tab-box-right">
                        <select class="select" v-model="info.method">
                          <option value="0">自分で候補日時を選択する方法</option>
                          <option value="1">複数候補から相手に同意を得る方法</option>
                        </select>
                        <template v-if="info.method">
                          <p v-if="info.method === 0">自分で空いている候補日時を一つ選択し、参加者に通知する方法です。</p>
                          <p v-if="info.method === 1">複数候補日時を参加者に通知し、選んでいただく方法です。(任意参加者・共有者は候補日を選ぶことができません。)</p>
                        </template>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>バッファ</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">予定間の空き時間を入力します</span>
                        </p>
                      </div>
                      <div class="tab-box-right">
                        <p style="display: flex; align-items: center;">
                          <b-numberinput size="is-small" style="width: 100px;" step="15" :editable="false" v-model="info.interval" min="0" max="120" controls-position="compact"></b-numberinput>
                          <span style="margin-left: 4px;">分</span>
                        </p>
                      </div>
                    </div>
                  </template>
                </b-tab-item>
                <template v-if="!isCreateFromDate">
                  <b-tab-item label="リマインダー設定" class="tab-box disp-scroll">
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>リマインダー通知</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">ONにすると設定したメールが届きます</span>
                        </p>
                      </div>
                      <div class="tab-box-right">
                        <b-switch style="width: 100%;" v-model="info.reminder_flg">切替</b-switch>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>リマインダー通知日</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">日程調整をした日の何日前に送るか設定します</span>
                        </p>
                      </div>
                      <div class="tab-box-right">
                        <p style="display: flex; align-items: center;">
                          <b-numberinput v-model="info.reminder_day" :editable="false" min="1" max="10" style="width: 100px;" size="is-small" controls-position="compact" :disabled="!info.reminder_flg"></b-numberinput>
                          <span style="margin-left: 4px;">日前</span>
                        </p>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>直前リマインダー通知</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">ONにすると登録された予定時間の直前に再度メールが届きます<br/>※30分〜120分前の間で設定可能です</span>
                        </p>
                      </div>
                      <div class="tab-box-right">
                        <b-switch style="width: 40%;" v-model="info.reminder_before_flg" :disabled="!info.reminder_flg">切替</b-switch>
                        <p style="display: flex; align-items: center;">
                          <b-numberinput style="width: 100px;" size="is-small" :editable="false" step="10" min="30" max="120" v-model="info.reminder_before_minute" controls-position="compact" :disabled="!info.reminder_flg||!info.reminder_before_flg"></b-numberinput>
                          <span style="margin-left: 4px;">分前</span>
                        </p>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>メンバーにも送付</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">ONにすると基本設定で選択したメンバーおよびユーザーにもメールが届きます</span>
                        </p>
                      </div>
                      <div class="tab-box-right">
                        <b-switch style="width: 100%;" v-model="info.reminder_member_flg" :disabled="!info.reminder_flg">切替</b-switch>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>メール内容</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">リマインダーメールの内容を設定できます</span>
                          <br>
                          <span style="color: #666; font-size: 12px;">メールはHRモンスター（noreply@hr-monster.io）からお送りいたします。</span>
                        </p>
                      </div>
                      <div class="tab-box-right" style="flex-wrap: wrap;">
                        <p style="width: 100%; text-align: left;font-weight: bold;">件名</p>
                        <b-input style="width: 100%;" placeholder="例：件名を入力" v-model="info.reminder_title" :disabled="!info.reminder_flg"></b-input>
                        <hr>
                        <p style="width: 100%; text-align: left;font-weight: bold;">TO（カンマ区切りで追加できます。）</p>
                        <b-input style="width: 100%;" placeholder="例：TOを入力" v-model="info.reminder_to" :disabled="!info.reminder_flg"></b-input>
                        <hr>
                        <p style="width: 100%; text-align: left;font-weight: bold;">CC（カンマ区切りで追加できます。）</p>
                        <b-input style="width: 100%;" placeholder="例：CCを入力" v-model="info.reminder_cc" :disabled="!info.reminder_flg"></b-input>
                        <hr>
                        <p style="width: 100%; text-align: left; font-weight: bold;">メールの内容を入力してください。</p>
                        <div style="width: 100%; height: auto;">
                          <quill-editor v-model="info.reminder_content" ref="quillEditor" :options="optionsRemainder" :disabled="!info.reminder_flg"></quill-editor>
                        </div>
                      </div>
                    </div>
                  </b-tab-item>
                </template>
                <b-tab-item label="ファイル添付" class="tab-box disp-scroll">
                  <div class="tab-box-form">
                    <div class="tab-box-left">
                      <p style="text-align: left;">
                        <b>ファイルを添付する</b>
                        <br>
                        <span style="color: #666; font-size: 12px;">スイッチをONにするとファイルを選択できます。</span>
                      </p>
                    </div>
                    <div class="tab-box-right" style="flex-wrap: wrap;">
                      <b-switch style="width: 100%;" size="is-small" v-model="isFileAttach"></b-switch>
                    </div>
                  </div>
                  <template v-if="isFileAttach">
                    <div class="tab-box-form" v-if="taskFiles.length > 0">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>タスクに添付されたファイル</b>
                        </p>
                      </div>
                      <div class="tab-box-right" style="flex-direction: column; padding-left: 8px;">
                        <p v-for="(f, idx) in taskFiles" :key="idx">・{{f.filename}}</p>
                      </div>
                    </div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>種類の選択</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">既存の会議予定と同じファイルグループに属する場合は「既存のファイルグループから選択」を選んでください。</span>
                          <br>
                          <span style="color: #666; font-size: 12px;">（既存のファイルグループに新たにファイルを作成することも可能です。）</span>
                        </p>
                      </div>
                      <div class="tab-box-right" style="flex-wrap: wrap; padding-left: 8px;">
                        <p style="width: 100%; text-align: left;"><b>新規 / 既存の選択</b></p>
                        <select class="select is-small" v-model="fileSelectType">
                          <option v-for="(s, i) in fileSelectList" :key="i" :value="i">
                            {{s}}
                          </option>
                        </select>
                        <!-- <div style="width: 100%;">
                          <p style="width: 100%; text-align: left;"><b>タグ（カンマ区切り）</b></p>
                          <input class="input is-small" placeholder="採用, 会議" v-model="tag"/>
                        </div> -->
                        <template v-if="fileSelectType === 0">
                          <p style="width: 100%; text-align: left;"><b>新規ファイルグループの名称</b></p>
                          <input class="input is-small" placeholder="○○会議の議事録群" v-model="groupName"/>
                        </template>
                        <template v-else>
                          <p style="width: 100%; text-align: left;"><b>既存ファイルグループの選択</b></p>
                          <select class="select is-small" v-model="tempEventFileGroup">
                            <option v-for="(s, i) in alreadyGroupFileList" :key="i" :value="s">
                              {{s.group_name}}
                            </option>
                          </select>
                          <p style="width: 100%; text-align: left; color: #666;" v-if="alreadyGroupFileList.length === 0">既存ファイルグループがございません。</p>
                        </template>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-left">
                      <p style="text-align: left;">
                        <b>ファイルの添付</b>
                        <br>
                        <span style="color: #666; font-size: 12px;">ファイル形式問わず添付が可能です。</span>
                        <!-- <br>
                        <span style="color: #666; font-size: 12px;">Web上の作成物の場合はURLを入力してください。</span> -->
                      </p>
                    </div>
                    <div class="tab-box-right" style="flex-wrap: wrap; padding-left: 8px;">
                      <div v-if="authType === 'google'">
                        <div v-if="!isGoogleDriveAuth">
                            ※現在このアカウントはGoogleDrive連携がされていません。連携がされていない状態でONで保存しますとファイルがアップロードされません。連携を行う場合は「設定」>
                          「外部連携」 > 「GoogleDrive連携」より連携をお願いいたします。
                          「外部連携」 > 「GoogleDrive連携」より連携をお願いいたします。
                          「外部連携」 > 「GoogleDrive連携」より連携をお願いいたします。<br>
                            ※GoogleDrive連携後、設定を開くからDriveのファイル保存先で、添付ファイルを経由するフォルダを選択してください。
                        </div>
                        <div v-else-if="!isCreated">
                            ※Googleカレンダーにファイルを添付するためのGoogleDriveフォルダが選択されていません。設定を開くからDriveのファイル保存先で、添付ファイルを経由するフォルダを選択してください。
                        </div>
                      </div>
                      <b-upload v-model="file" drag-drop multiple>
                        <section class="upload-section">
                          <div class="content has-text-centered">
                            <p>
                              <b-icon icon="upload" size="is-large"></b-icon>
                            </p>
                            <p>ファイルをアップロードしてください</p>
                          </div>
                        </section>
                      </b-upload>
                      <p style="margin-top: 8px; white-space: pre-wrap;">
                        <template v-if="file.length > 0">
                          <span class="tag is-primary" style="margin: 2px;" v-for="(f, idx) in file" :key="idx">
                            {{f.name}}
                            <button class="delete is-small" type="button" @click="file.splice(idx, 1)"></button>
                          </span>
                        </template>
                        <template v-else>未アップロードです。</template>
                      </p>
                      <!-- <div style="display: flex; align-items: center; margin-top: 8px;">
                        <p>URL：</p>
                        <input class="input is-small" placeholder="https://hogehoge.com" maxlength="255" v-model="url"/>
                      </div> -->
                    </div>
                    <template v-if="fileSelectType === 1">
                      <div class="dot-line"></div>
                      <div class="tab-box-form">
                        <div class="tab-box-left">
                          <p style="text-align: left;">
                            <b>既存のファイルから選択</b>
                            <br>
                            <span style="color: #666; font-size: 12px;">既存のファイルから選択できます。</span>
                          </p>
                        </div>
                        <div class="tab-box-right" style="flex-wrap: wrap;">
                          <select class="select" v-model="alreadyFile">
                            <option v-for="(f, i) in alreadyFileList" :key="i" :value="f.event_file_ref">
                              {{f.event_file_ref.filename}}
                            </option>
                          </select>
                          <a style="width: 100%; text-align: left;" target="_blank" :href="alreadyFile.file" v-if="alreadyFile">{{alreadyFile.filename}}を開く</a>
                        </div>
                      </div>
                    </template>
                  </template>
                </b-tab-item>
                <template v-if="isCreateFromDate">
                  <b-tab-item label="メール" class="tab-box disp-scroll">
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>メール送付</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">スイッチをONにするとカレンダー作成後、メールを送付できます。</span>
                        </p>
                      </div>
                      <div class="tab-box-right" style="flex-wrap: wrap;">
                        <b-switch style="width: 100%;" size="is-small" v-model="isMailSend"></b-switch>
                      </div>
                    </div>
                    <template v-if="isMailSend">
                      <div class="tab-box-form">
                        <div class="tab-box-left">
                          <p style="text-align: left;">
                            <b>メール内容</b>
                            <br>
                            <span style="color: #666; font-size: 12px;">日時、タイトル、メモ以外にメッセージを追加する場合は記載ください。</span>
                          </p>
                        </div>
                        <div class="tab-box-right" style="flex-wrap: wrap;">
                          <textarea class="textarea is-small disp-scroll" style="height: 200px;" v-model="mailContent"></textarea>
                        </div>
                      </div>
                    </template>
                  </b-tab-item>
                </template>
              </b-tabs>
            </div>
            <b-field style="width: 100%">
              <div style="width: 48%; align: left">
                <button class="button is-primary is-fullwidth" @click="closeEditPage();">
                  キャンセル
                </button>
              </div>
              <div style="width: 5%;">
              </div>
              <div style="width: 48%; align: right">
                <template v-if="isCreateFromDate">
                  <button class="button is-primary is-fullwidth" @click="clickSaveEvent();" :class="{ 'not-create': isFileAttach && isGoogleDriveAuth && !isCreated }">
                    作成
                  </button>
                </template>
                <template v-else>
                  <button class="button is-primary is-fullwidth" @click="clickRecommendEvent()">
                    候補日時作成
                  </button>
                </template>
              </div>
            </b-field>
          </template>
          <template v-if="step===1">
            <div class="message">
              <template v-if="!isRecommendSchedule">
                <div style="height: auto; width: 100%; display: flex; justify-content: center; align-items: center;">
                  <span class="mdi mdi-loading mdi-spin"></span>候補日時を読み込んでいます
                </div>
              </template>
              <template v-else-if="isErrorRecommendSchedule&&isRecommendSchedule">
                <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
                  候補日時をお取りすることができませんでした。<br>
                  本画面を閉じていただき、もう一度設定をご確認の上、候補日作成をお願いいたします。
                </div>
              </template>
              <template v-else>
                <div style="height: auto; width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column;">
                  <p class="message-title" style="font-weight: 600; font-size: 18px; margin: 16px;">日付をお選びください。</p>
                  <template v-if="info.method === 0">
                    <button
                      v-for="(m, index) in recommendDateButton"
                      :key="index"
                      v-if="m"
                      class="button"
                      style="margin: 8px;"
                      :disabled="isdisabled"
                      @click="makeEvent(m, index)"
                    >{{ m }}</button>
                  </template>
                  <template v-else>
                    <button
                      v-for="(m, index) in recommendDateButton"
                      :key="index"
                      v-if="m"
                      class="button"
                      style="margin: 8px;"
                      :disabled="isdisabled"
                      @click="addEventKouho(m, index)"
                    >{{ m }}</button>
                    <hr>
                    <ul>
                      <li v-for="(s, i) in kouhoBi" :key="i">{{s.date}}</li>
                    </ul>
                    <button class="button is-primary" @click="makeEventPre()">上記候補日時で調整する</button>
                  </template>
                </div>
              </template>
            </div>
            <hr>
            <b-field style="width: 100%">
              <div style="width: 48%; align: left">
                <button class="button is-primary is-fullwidth" @click="prevDay()" :disabled="!isRecommendSchedule||isErrorRecommendSchedule||preserveSuggestedSchedulesList.length === 0">
                  前の候補日時へ
                </button>
              </div>
              <div style="width: 5%;">
              </div>
              <div style="width: 48%; align: right">
                <button class="button is-primary is-fullwidth" @click="nextDay()" :disabled="!isRecommendSchedule||isErrorRecommendSchedule">
                  次の候補日時へ
                </button>
              </div>
            </b-field>
          </template>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import createUUID from '@/functions/createUUID'
import CalendarAPIStatus from '@/views/DashBoard/Calendar/CalendarAPIStatus'
import _ from 'lodash'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import SelectMemberTable from '@/components/molecules/tables/SelectMemberTable'
export default {
  name: 'ModalCreateEvent',
  components: {
    CalendarAPIStatus,
    Tooltip,
    SelectMemberTable
  },
  props: {
    calendarSettings: {
      type: Array,
      require: true
    },
    isGoogleDriveAuth: {
      type: Boolean,
      require: true
    },
    authType: {
      type: String,
      require: true
    },
    userId    : {
      type    : String,
      required: true,
      default : ''
    },
    drive_info: {
      type: Object,
      required: true
    },
    isCreated: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState('auth', ['user', 'users', 'departments', 'positions', 'usersStatusAPI']),
    ...mapState('calendar', ['recommendDate', 'isErrorRecommendSchedule', 'preserveSuggestedSchedulesList', 'isRecommendSchedule', 'eventFileGroup', 'eventGroup']),
    recommendDateButton () {
      let retRecommendDate = []
      for (const i in this.recommendDate) {
        retRecommendDate.push(
          new Date(this.recommendDate[i].start).getMonth() + 1 + '/' + new Date(this.recommendDate[i].start).getDate() + ' (' +  this.weekday[new Date(this.recommendDate[i].start).getDay()] + ') ' +
          new Date(this.recommendDate[i].start).getHours() +     ':' + ('00' + new Date(this.recommendDate[i].start).getMinutes()).slice(-2) + ' ~ ' +
          new Date(this.recommendDate[i].end).getHours()   +     ':' + ('00' + new Date(this.recommendDate[i].end).getMinutes()).slice(-2)
        )
      }
      return retRecommendDate
    },
    alreadyGroupFileList () {
      return this.eventFileGroup.filter((element, index, self) =>
        self.findIndex(e => e.group_name === element.group_name) === index)
    },
    alreadyFileList () {
      if (this.tempEventFileGroup) {
        let tempFilter = this.eventFileGroup.filter((element, index, self) =>
        self.findIndex(e => e.event_file_ref.filename === element.event_file_ref.filename) === index)
        return tempFilter.filter((element, index, self) =>
          self.slice(0, self.length).filter(el => el.group_name === this.tempEventFileGroup.group_name))
      } else {
        []
      }
    }
  },
  data () {
    return {
      isCreateFromDate: false,
      info: null,
      isCardModalActive: false,
      timeList: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23
      ],
      weekdayList: [
        '月', '火', '水', '木', '金', '土', '日'
      ],
      weekday: [
        '日', '月', '火', '水', '木', '金', '土'
      ],
      optionsRemainder: {
        theme: 'snow',
        placeholder: '内容を入力...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
        }
      },
      isMailSend: false,
      mailContent: null,
      isFileAttach: false,
      tempEventFileGroup: null,
      groupName: null,
      url: null,
      file: [],
      alreadyFile: null,
      fileSelectType: 0,
      fileSelectList: ['新しいファイルグループを作成', '既存のファイルグループから選択'],
      start: new Date(2000, 1, 1, 9, 0),
      end: new Date(2000, 1, 1, 18, 0),
      step: 0,
      preventClick: false,
      kouhoBi: [],
      taskFiles: [],
      isdisabled: false,
      errFlag: false,
      filecnt: 0,
      repeatMinDate: new Date(2000, 1, 1, 9, 0),
      repeatMaxDate: new Date(2000, 1, 1, 18, 0),
      isRepeat: false,
      repeatInterval: 'day',
      repeatWeekDay: [],
      repeatEndDate: new Date(2000, 1, 1, 18, 0)
    }
  },
  watch: {
    isCardModalActive () {
      if (this.isCardModalActive) {
        this.file = []
        this.filecnt = 0
        this.alreadyFile = null
        if (!this.isTask) {
          this.taskFiles = []
          this.isFileAttach = false
        }
      }
    },
    "info.start" () {
      if (this.isRepeat) {
        this.changeRepeatDate(true)
      }
    }
  },
  methods: {
    setDepartment (d) {
      let tempUsers = []
      for (const u of this.users) {
        for (const ud of u.departments) {
          if (ud.pk === d.pk) tempUsers.push(u.pk)
        }
      }
      return tempUsers
    },
    setPositions (p) {
      let tempUsers = []
      for (const u of this.users) {
        for (const up of u.positions) {
          if (up.pk === p.pk) tempUsers.push(u)
        }
      }
      return tempUsers
    },
    addEventKouho (m, i) {
      if (this.kouhoBi.length >= 3) {
        alert('候補日時は3つまでです。')
        return
      }
      let flg = false
      for (const k of this.kouhoBi) {
        if (k.date === m) flg = true
      }
      if (flg) {
        alert('同じ候補日時は設定できません')
        return
      }
      var start = new Date(
        new Date(
          (new Date().getFullYear() + '/' + m).split('~')[0]
        ).toLocaleString('ja-JP')
      )
      var end = null
      if (this.info.mtg_time_hour === undefined) {
        this.info.mtg_time_hour = Math.floor(this.info.mtg_time)
      }
      end = new Date(new Date(moment(start).add('hours', this.info.mtg_time_hour).add('minutes', this.info.mtg_time_minute)).toLocaleString('ja-JP'))
      this.kouhoBi.push({
        index: i,
        date: m,
        start: start,
        end: end,
        data: this.recommendDate[i]
      })
    },
    clickSaveEvent () {
      if (this.info.calendarType == 'nolinkage') {
        if (this.info.start > this.info.end) {
          alert('開始日時は終了日時より前に設定してください。')
          return
        }
        if (this.isRepeat) {
          this.info.repeat = this.isRepeat
          this.info.repeat_interval = this.repeatInterval
          this.info.repeat_week = this.repeatWeekDay
          this.info.repeat_end = this.repeatEndDate
          if (!confirm(`${this.getDateCount()}個の繰り返し予定を登録します。一度登録された予定を変更する場合、それぞれの予定ごとに編集する必要がありますがよろしいですか。`)) return
        }
      }
      let dfunc = function x(x) {
        let t = x
        return t
      }
      let tempInfo = dfunc(this.info)
      for (const d of this.info.attendees_departments) {
        let tempUsers = this.setDepartment(d)
        for (const t of tempUsers) {
          let flg = false
          for (const a of this.info.attendees) {
            if (t === a) {
              flg = true
            }
          }
          if (!flg) tempInfo.attendees.push(t)
        }
      }
      for (const p of this.info.attendees_positions) {
        let tempUsers = this.setPositions(p)
        for (const t of tempUsers) {
          let flg = false
          for (const a of this.info.attendees) {
            if (t === a) {
              flg = true
            }
          }
          if (!flg) tempInfo.attendees.push(t)
        }
      }
      this.$store.dispatch('calendar/createSchedules', tempInfo)
        .then((retEventData) => {
          for (let eventData of retEventData) {
            let attachments = []
            // タスク経由の作成の場合
            if (this.isFileAttach && this.taskFiles.length > 0) {
              for (const f of this.taskFiles) {
                this.$store.dispatch('calendar/createEventFileFromTask', f)
                  .then((eventFileData) => {
                    if (this.isGoogleDriveAuth) {
                      // Google Drive連携時にCalendarに添付ファイルを追加
                      let eventInfo = {
                        event_data: eventData,
                        event_file_data_id: eventFileData.pk
                      }
                      this.$store.dispatch('calendar/createGoogleDriveAttachmentFile', eventInfo)
                        .then((attachment) => {
                          attachments.push(attachment)
                          this.filecnt++
                          this.uploadGoogleCalendarAttachmentFile(attachments, eventData)
                        })
                        .catch((e) => {
                          this.errFlag = true
                        })
                    }
                    let tempEFG = {
                      group_name: f.filename ? f.filename : this.info.title,
                      user: this.user.userHash,
                      event_file: eventFileData.pk
                    }
                    if (this.info.attendees.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventFileGroup', tempEFG)
                    for (let u of this.info.attendees) {
                      let tempEFGChild = Object.assign({}, tempEFG)
                      tempEFGChild.user = u
                      this.$store.dispatch('calendar/createEventFileGroup', tempEFGChild)
                    }
                    let tempEG = {
                      calendar_id: eventData.id,
                      user: this.user.userHash,
                      event_file: eventFileData.pk
                    }
                    if (this.info.attendees.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventGroup', tempEG)
                    for (let u of this.info.attendees) {
                      let tempEGChild = Object.assign({}, tempEG)
                      tempEGChild.user = u
                      this.$store.dispatch('calendar/createEventGroup', tempEGChild)
                    }
                  })
              }
            // 新規作成の場合
            } else if (this.file.length > 0 && this.isFileAttach && this.fileSelectType === 0) {
              for (const f of this.file) {
                let attachedFile = new FormData()
                attachedFile.append('file', f)
                attachedFile.append('filename', f.name)
                attachedFile.append('url', this.url)
                this.$store.dispatch('calendar/createEventFile', attachedFile)
                  .then((eventFileData) => {
                    if (this.isGoogleDriveAuth) {
                      // Google Drive連携時にCalendarに添付ファイルを追加
                      let eventInfo = {
                        event_data: eventData,
                        event_file_data_id: eventFileData.pk
                      }
                      this.$store.dispatch('calendar/createGoogleDriveAttachmentFile', eventInfo)
                        .then((attachment) => {
                          attachments.push(attachment)
                          this.filecnt++
                          this.uploadGoogleCalendarAttachmentFile(attachments, eventData)
                        })
                        .catch((e) => {
                          this.errFlag = true
                        })
                    }
                    let tempEFG = {
                      group_name: this.groupName ? this.groupName : this.info.title,
                      user: this.user.userHash,
                      event_file: eventFileData.pk
                    }
                    if (this.info.attendees.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventFileGroup', tempEFG)
                    for (let u of this.info.attendees) {
                      let tempEFGChild = Object.assign({}, tempEFG)
                      tempEFGChild.user = u
                      this.$store.dispatch('calendar/createEventFileGroup', tempEFGChild)
                    }
                    let tempEG = {
                      calendar_id: eventData.id,
                      user: this.user.userHash,
                      event_file: eventFileData.pk
                    }
                    if (this.info.attendees.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventGroup', tempEG)
                    for (let u of this.info.attendees) {
                      let tempEGChild = Object.assign({}, tempEG)
                      tempEGChild.user = u
                      this.$store.dispatch('calendar/createEventGroup', tempEGChild)
                    }
                  })
              }
            // 既存グループに新規ファイルを追加の場合
            } else if (this.file.length > 0 && this.isFileAttach && this.fileSelectType === 1 && this.tempEventFileGroup) {
              for (const f of this.file) {
                let attachedFile = new FormData()
                attachedFile.append('file', f)
                attachedFile.append('filename', f.name)
                attachedFile.append('url', this.url)
                this.$store.dispatch('calendar/createEventFile', attachedFile)
                  .then((eventFileData) => {
                    if (this.isGoogleDriveAuth) {
                      // Google Drive連携時にCalendarに添付ファイルを追加
                      let eventInfo = {
                        event_data: eventData,
                        event_file_data_id: eventFileData.pk
                      }
                      this.$store.dispatch('calendar/createGoogleDriveAttachmentFile', eventInfo)
                        .then((attachment) => {
                          attachments.push(attachment)
                          this.filecnt++
                          this.uploadGoogleCalendarAttachmentFile(attachments, eventData)
                        })
                        .catch((e) => {
                          this.errFlag = true
                        })
                    }
                    let tempEFG = {
                      group_name: this.tempEventFileGroup.group_name,
                      user: this.user.userHash,
                      event_file: eventFileData.pk
                    }
                    if (this.info.attendees.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventFileGroup', tempEFG)
                    for (let u of this.info.attendees) {
                      let tempEFGChild = Object.assign({}, tempEFG)
                      tempEFGChild.user = u
                      this.$store.dispatch('calendar/createEventFileGroup', tempEFGChild)
                    }
                    let tempEG = {
                      calendar_id: eventData.id,
                      user: this.user.userHash,
                      event_file: eventFileData.pk
                    }
                    if (this.info.attendees.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventGroup', tempEG)
                    for (let u of this.info.attendees) {
                      let tempEGChild = Object.assign({}, tempEG)
                      tempEGChild.user = u
                      this.$store.dispatch('calendar/createEventGroup', tempEGChild)
                    }
                  })
              }
            // 既存グループの既存ファイル追加の場合
            } else if (this.file.length === 0 && this.isFileAttach && this.fileSelectType === 1 && this.alreadyFile) {
              if (this.isGoogleDriveAuth) {
                // Google Drive連携時にCalendarに添付ファイルを追加
                let eventInfo = {
                  event_data: eventData,
                  event_file_data_id: this.alreadyFile.pk
                }
                this.$store.dispatch('calendar/createGoogleDriveAttachmentFile', eventInfo)
                  .then((attachment) => {
                    attachments.push(attachment)
                    this.filecnt++
                    this.uploadGoogleCalendarAttachmentFile(attachments, eventData)
                  })
                  .catch((e) => {
                    this.errFlag = true
                  })
              }
              let tempEFG = {
                group_name: this.tempEventFileGroup.group_name,
                user: this.user.userHash,
                event_file: this.alreadyFile.pk
              }
              if (this.info.attendees.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventFileGroup', tempEFG)
              for (let u of this.info.attendees) {
                let tempEGChild = Object.assign({}, tempEG)
                tempEFGChild.user = u
                this.$store.dispatch('calendar/createEventFileGroup', tempEGChild)
              }
              let tempEG = {
                calendar_id: eventData.id,
                user: this.user.userHash,
                event_file: this.alreadyFile.pk
              }
              this.$store.dispatch('calendar/createEventGroup', tempEG)
              for (let u of this.info.attendees) {
                let tempEGChild = tempEG
                tempEGChild.user = u
                this.$store.dispatch('calendar/createEventGroup', tempEG)
              }
            }
          }
        })
      this.closeEditPage();
    },
    clickRecommendEvent () {
      this.kouhoBi = []
      let dfunc = function x(x) {
        let t = x
        return t
      }
      let param = dfunc(this.info)
      if (isNaN(this.info.after)) param.after = 1
      param.mtg_time = 1
      param.count = 3
      param.no_candidate = ''
      param.until = 60
      param.company_hash = this.user.companyID
      let start_hour = this.start.getHours()
      let start_minute = this.start.getMinutes()
      let end_hour = this.end.getHours()
      let end_minute = this.end.getMinutes()
      param.work_time_start = parseFloat(start_hour + (start_minute / 100))
      param.work_time_end = parseFloat(end_hour + (end_minute / 100))
      // 開始日を計算
      let now = new Date()
      now = new Date(now.setSeconds(0))
      now = new Date(now.setHours(param.work_time_start))
      now = new Date(now.setMinutes((param.work_time_start * 100) - (now.getHours() * 100)))
      let nextDay = new Date(now.setDate(new Date().getDate() + param.after))
      param.after = nextDay.toLocaleString('ja-JP')
      for (var i in param.user_hash) {
        var temp1 = param.user_hash_sub.indexOf(param.user_hash[i])
        if (temp1 >= 0) param.user_hash_sub.splice(temp1, 1)
        var temp2 = param.user_hash_share.indexOf(param.user_hash[i])
        if (temp2 >= 0) param.user_hash_share.splice(temp2, 1)
      }
      for (var i in param.user_hash_sub) {
        var temp = param.user_hash_share.indexOf(param.user_hash_sub[i])
        if (temp >= 0) param.user_hash_share.splice(temp, 1)
      }
      if (this.isErrorCheck(param)) {
        this.$store.dispatch('calendar/getRecommendSchedule', param)
        this.step = 1
      }
    },
    closeEditPage () {
      this.repeatMinDate = new Date(2000, 1, 1, 9, 0)
      this.repeatMaxDate = new Date(2000, 1, 1, 18, 0)
      this.isRepeat = false
      this.repeatInterval = 'day'
      this.repeatWeekDay = []
      this.repeatEndDate = new Date(2000, 1, 1, 18, 0)
      this.isCardModalActive = false
    },
    nextDay () {
      let param = this.info
      this.$store.dispatch('calendar/preserveSuggestedSchedules',
        {
          suggestedSchedules: this.recommendDate,
          targetID: null
        }
      )
      param.after = new Date(moment(this.recommendDate[2].start).add('minutes', 30)).toLocaleString('ja-JP')
      this.$store.dispatch('calendar/getRecommendSchedule', param)
      console.debug('*** End *** nextDay')
    },
    prevDay () {
      let param = this.info
      if (this.preserveSuggestedSchedulesList.length === 1) {
        let now = new Date()
        now = new Date(now.setSeconds(0))
        now = new Date(now.setHours(param.work_time_start))
        now = new Date(now.setMinutes((param.work_time_start * 100) - (now.getHours() * 100)))
        let nextDay = new Date(now.setDate(new Date().getDate() + 1))
        param.after = nextDay.toLocaleString('ja-JP')
        this.$store.dispatch('calendar/restoreSuggestedSchedules')
      } else if (this.preserveSuggestedSchedulesList.length > 1) {
        const beforeTwoSuggestedSchedule = this.preserveSuggestedSchedulesList[this.preserveSuggestedSchedulesList.length - 2]
        param.after = new Date(moment(beforeTwoSuggestedSchedule[2].start).add('minutes', 30)).toLocaleString('ja-JP')
        this.$store.dispatch('calendar/restoreSuggestedSchedules')
      } else if (this.preserveSuggestedSchedulesList.length === 0) {
        return
      }
      console.log('param: ', param)
      this.$store.dispatch('calendar/getRecommendSchedule', param)
      console.debug('*** End *** prevDay')
    },
    makeEventPre () {
      if (this.kouhoBi.length <= 2) {
        alert('候補日時は3つまでお選びください。')
        return
      }
      this.$store.dispatch('calendar/sendScheduleEmail', {
        'to': this.info.user_hash,
        'calendarType': this.info.calendarType,
        'title': '【HRモンスター】' + this.info.title + 'の予定調整をお願いいたします。',
        'method': this.info.method,
        'info': this.info,
        'dateJson': this.kouhoBi
      })
      alert('関係者に調整メールをお送りいたしました。')
      this.closeEditPage()
    },
    makeEvent (m, btnIndex) {
      this.isdisabled = true
      this.$store.dispatch('calendar/resetSuggestedSchedules')
      var u_hash = []
      let tempUsersHash = new Set(this.info.user_hash)
      for (const d of this.info.user_hash_departments) {
        let tempUsers = this.setDepartment(d)
        for (const t of tempUsers) {
          let flg = false
          for (const a of this.info.user_hash) {
            if (t === a) {
              flg = true
            }
          }
          if (!flg) tempUsersHash.add(t)
        }
      }
      for (const p of this.info.user_hash_positions) {
        let tempUsers = this.setPositions(p)
        for (const t of tempUsers) {
          let flg = false
          for (const a of this.info.user_hash) {
            if (t === a) {
              flg = true
            }
          }
          if (!flg) tempUsersHash.add(t)
        }
      }
      tempUsersHash.add(this.recommendDate[btnIndex].uuid)
      u_hash = Array.from(tempUsersHash)
      var u_hash_share = this.info.user_hash_share
      const id = createUUID()
      var location = ''
      var start = new Date(
        new Date(
          (new Date().getFullYear() + '/' + m).split('~')[0]
        ).toLocaleString('ja-JP')
      )
      var end = null
      if (this.info.mtg_time_hour === undefined) {
        this.info.mtg_time_hour = Math.floor(this.info.mtg_time)
      }
      if (this.info.mtg_time_minute === undefined) {
        this.info.mtg_time_minute = parseInt((this.info.mtg_time - Math.floor(this.info.mtg_time)) * 60)
      }
      end = new Date(
      new Date(moment(start).add('hours', this.info.mtg_time_hour).add('minutes', this.info.mtg_time_minute)).toLocaleString('ja-JP'))
      var isAllDay = false
      var category = 'time'
      var state = ''
      var isVisible = true
      var isPrivate = 'public'
      var isReadOnly = false
      var color = '#000'
      var bgColor = '#59C8C9'
      var borderColor = '#59C8C9'
      var dragBgColor = '#59C8C9'
      var u_h = []
      var isError = false
      if (this.recommendDate[btnIndex].uuid.split(',').length > 1) u_h = this.recommendDate[btnIndex].uuid.split(',')
      else u_h.push(this.recommendDate[btnIndex].uuid)
      var createdSchedule = {
        id: id,
        scheduleId: id,
        user_hash: u_h,
        user_hash_list: u_hash,
        user_hash_share: u_hash_share,
        company_hash: this.info.company_hash,
        title: this.info.title,
        location: location,
        start: start,
        end: end,
        memo: this.info.memo ? this.info.memo : '',
        isAllDay: isAllDay,
        category: category,
        state: state,
        isVisible: isVisible,
        isPrivate: isPrivate,
        isReadOnly: isReadOnly,
        color: color,
        bgColor: bgColor,
        borderColor: borderColor,
        dragBgColor: dragBgColor,
        is_AND: this.info.is_AND,
        re_message: m,
        is_private: isPrivate
      }
      this.$store.dispatch('calendar/autoCreateSchedule', createdSchedule)
        .then((retEventData) => {
          for (let eventData of retEventData) {
            let attachments = []
            if(eventData == null) {
              alert('エラーが発生しました。再度登録しなおしてください。')
              this.isdisabled = false
              return true
            }
            // 新規作成の場合
            if (this.file.length > 0 && this.isFileAttach && this.fileSelectType === 0) {
              for (const f of this.file) {
                let attachedFile = new FormData()
                attachedFile.append('file', f)
                attachedFile.append('filename', f.name)
                attachedFile.append('url', this.url)
                this.$store.dispatch('calendar/createEventFile', attachedFile)
                  .then((eventFileData) => {
                    if (this.isGoogleDriveAuth) {
                      // Google Drive連携時にCalendarに添付ファイルを追加
                      let eventInfo = {
                        event_data: eventData,
                        event_file_data_id: eventFileData.pk
                      }
                      this.$store.dispatch('calendar/createGoogleDriveAttachmentFile', eventInfo)
                        .then((attachment) => {
                          attachments.push(attachment)
                          this.filecnt++
                          this.uploadGoogleCalendarAttachmentFile(attachments, eventData)
                        })
                        .catch((e) => {
                          this.errFlag = true
                        })
                    }
                    let tempEFG = {
                      group_name: this.groupName ? this.groupName : eventData.title,
                      user: this.user.userHash,
                      event_file: eventFileData.pk
                    }
                    if (u_hash.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventFileGroup', tempEFG)
                    for (let u of u_hash) {
                      let tempEFGChild = Object.assign({}, tempEFG)
                      tempEFGChild.user = u
                      this.$store.dispatch('calendar/createEventFileGroup', tempEFGChild)
                    }
                    let tempEG = {
                      calendar_id: eventData.id,
                      user: this.user.userHash,
                      event_file: eventFileData.pk
                    }
                    if (u_hash.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventGroup', tempEG)
                    for (let u of u_hash) {
                      let tempEGChild = Object.assign({}, tempEG)
                      tempEGChild.user = u
                      this.$store.dispatch('calendar/createEventGroup', tempEGChild)
                    }
                  })
              }
            // 既存グループに新規ファイルを追加の場合
            } else if (this.file.length > 0 && this.isFileAttach && this.fileSelectType === 1 && this.tempEventFileGroup) {
              for (const f of this.file) {
                let attachedFile = new FormData()
                attachedFile.append('file', f)
                attachedFile.append('filename', f.name)
                attachedFile.append('url', this.url)
                this.$store.dispatch('calendar/createEventFile', attachedFile)
                  .then((eventFileData) => {
                    if (this.isGoogleDriveAuth) {
                      // Google Drive連携時にCalendarに添付ファイルを追加
                      let eventInfo = {
                        event_data: eventData,
                        event_file_data_id: eventFileData.pk
                      }
                      this.$store.dispatch('calendar/createGoogleDriveAttachmentFile', eventInfo)
                        .then((attachment) => {
                          attachments.push(attachment)
                          this.filecnt++
                          this.uploadGoogleCalendarAttachmentFile(attachments, eventData)
                        })
                        .catch((e) => {
                          this.errFlag = true
                        })
                    }
                    let tempEFG = {
                      group_name: this.tempEventFileGroup.group_name,
                      user: this.user.userHash,
                      event_file: eventFileData.pk
                    }
                    if (u_hash.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventFileGroup', tempEFG)
                    for (let u of u_hash) {
                      let tempEFGChild = Object.assign({}, tempEFG)
                      tempEFGChild.user = u
                      this.$store.dispatch('calendar/createEventFileGroup', tempEFGChild)
                    }
                    let tempEG = {
                      calendar_id: eventData.id,
                      user: this.user.userHash,
                      event_file: eventFileData.pk
                    }
                    if (u_hash.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventGroup', tempEG)
                    for (let u of u_hash) {
                      let tempEGChild = Object.assign({}, tempEG)
                      tempEGChild.user = u
                      this.$store.dispatch('calendar/createEventGroup', tempEGChild)
                    }
                  })
              }
            // 既存グループの既存ファイル追加の場合
            } else if (this.file.length === 0 && this.isFileAttach && this.fileSelectType === 1 && this.alreadyFile) {
              if (this.isGoogleDriveAuth) {
                // Google Drive連携時にCalendarに添付ファイルを追加
                let eventInfo = {
                  event_data: eventData,
                  event_file_data_id: this.alreadyFile.pk
                }
                this.$store.dispatch('calendar/createGoogleDriveAttachmentFile', eventInfo)
                  .then((attachment) => {
                    attachments.push(attachment)
                    this.filecnt++
                    this.uploadGoogleCalendarAttachmentFile(attachments, eventData)
                  })
                  .catch((e) => {
                    this.errFlag = true
                  })
              }
              let tempEFG = {
                group_name: this.tempEventFileGroup.group_name,
                user: this.user.userHash,
                event_file: this.alreadyFile.pk
              }
              if (u_hash.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventFileGroup', tempEFG)
              for (let u of u_hash) {
                let tempEFGChild = Object.assign({}, tempEFG)
                tempEFGChild.user = u
                this.$store.dispatch('calendar/createEventFileGroup', tempEFGChild)
              }
              let tempEG = {
                calendar_id: eventData.id,
                user: this.user.userHash,
                event_file: this.alreadyFile.pk
              }
              if (u_hash.includes(this.user.userHash) == false) this.$store.dispatch('calendar/createEventGroup', tempEG)
              for (let u of u_hash) {
                let tempEGChild = Object.assign({}, tempEG)
                tempEGChild.user = u
                this.$store.dispatch('calendar/createEventGroup', tempEGChild)
              }
            }
          }
          this.$store.dispatch('calendar/sendScheduleEmail', {
            'to': u_hash,
            'title': '【HRモンスター】' + this.info.title + 'の予定を調整いたしました。',
            'method': this.info.method,
            'info': this.info,
            'dateJson': retEventData,
            'date_str': m
          })
          alert('予定をお取りいたしました。カレンダーをご確認ください。')
          this.$store.dispatch('auth/createUserCalendarEventHistory', {
            name: this.getUserName(u_hash),
            user: this.user.userHash,
            parameter: this.info
          })
        // リマインドメール用
        if (this.info.reminder_flg) {
          var param = this.info
          param.date = m
          param.reminder_start = start
          var jstz = require('jstimezonedetect')
          param.reminder_tz = jstz.determine().name()
          this.$store.dispatch('chatbot/sendReminderEmail', {id: null, param: param})
        }
        this.isdisabled = false
        this.isCardModalActive = false
      })
      .catch((e) => {
        // 通信に失敗したので再度日程を送信してもらう
        this.isdisabled = false
        console.error(e)
        alert('エラーが発生しました。再度登録しなおしてください。')
        return true
      })
    },
    getUserName (user_hash) {
      let retStr = ''
      let filteredUsers = user_hash.filter(function (x, i, self) {
        return self.indexOf(x) === i
      })
      for (const u of this.users) {
        for (const u2 of filteredUsers) {
          if (u.user_hash === u2) {
            retStr += u.username + ' '
          }
        }
      }
      return retStr
    },
    isErrorCheck (param) {
      if (!param.title) {
        alert('タイトルを入力してください')
        return false
      } else {
        if (param.title.length == 0) {
          alert('タイトルを入力してください')
          return false
        }
      }
      // 面談時間チェック
      if (param.mtg_time_hour <= 0 && param.mtg_time_minute <= 0) {
        alert('面談時間は0より大きい値を入力してください: 2')
        return false
      }
      if ( param.mtg_time_hour > 24 ||
          (param.mtg_time_hour === 24 && param.mtg_time_minute > 0)
        ) {
        alert('面談時間は24時間以内にしてください')
        return false
      }
      if (param.mtg_time_minute > 59) {
        alert('面談時間の分の項目につきましては60分より小さい値を入力してください')
        return false
      }
      // 面談日チェック
      if ((this.end - this.start) < ((param.mtg_time_hour * 3600 + param.mtg_time_minute * 60 + param.interval * 2 * 60) * 1000)) {
        alert('調整可能日時は面談時間以上になるように設定してください。\n（バッファの時間×２と面談時間の合計が、調整可能日時を超えていないかの確認もお願いいたします。）')
        return false
      }
      // 間の時間チェック
      if (param.interval > 120) {
        alert('バッファにつきましては120分以内になるように設定してください。')
        return false
      }
      if (param.interval < 5 && param.interval > 0) {
        alert('バッファにつきましては設定する場合、5分以上になるように設定してください。')
        return false
      }
      // 休日チェック
      if (param.holiday_list.length > 6) {
        alert('休日が全ての曜日にチェックされております。いずれかの曜日のチェックを外してください。')
        return false
      }
      // ユーザーチェック
      if (param.user_hash.length === 0) {
        alert('調整するメンバーを一人以上選択してください。')
        return false
      }
      // リマインダーチェック
      if (param.reminder_flg) {
        // リマインダー：メールチェック（タイトル）
        if (!param.reminder_title) {
          alert('リマインダーメールのタイトルを入力してください')
          return false
        } else {
          if (param.reminder_title.length == 0) {
            alert('リマインダーメールのタイトルを入力してください')
            return false
          }
        }
        // リマインダー：メールチェック（To）
        if (!param.reminder_to) {
          alert('リマインダーメールの宛先（To）を入力してください')
          return false
        } else {
          if (param.reminder_to.length == 0) {
            alert('リマインダーメールの宛先（To）を入力してください')
            return false
          }
        }
        // リマインダー：メールチェック（Content）
        if (!param.reminder_content) {
          alert('リマインダーメールの内容を入力してください')
          return false
        } else {
          if (param.reminder_content.length == 0) {
            alert('リマインダーメールの内容を入力してください')
            return false
          }
        }
      }
      return true
    },
    changeAttendees (cs) {
      this.info.attendees = _.xor(this.info.attendees, [cs.calendar_user])
    },
    changeAttendeesSelf (data) {
      this.info.attendees = _.xor(this.info.attendees, [this.user.userHash])
    },
    changeAttendeesFromNo (data) {
      this.info.attendees = _.xor(this.info.attendees, [data.user.user_hash])
    },
    changeUserHash (cs) {
      this.info.user_hash = _.xor(this.info.user_hash, [cs.calendar_user])
    },
    changeUserHashSelf (data) {
      this.info.user_hash = _.xor(this.info.user_hash, [this.user.userHash])
    },
    changeUserHashFromNo (data) {
      this.info.user_hash = _.xor(this.info.user_hash, [data.user.user_hash])
    },
    changeUserHashSub (cs) {
      this.info.user_hash_sub = _.xor(this.info.user_hash_sub, [cs.calendar_user])
    },
    changeUserHashSubSelf (data) {
      this.info.user_hash_sub = _.xor(this.info.user_hash_sub, [this.user.userHash])
    },
    changeUserHashSubFromNo (data) {
      this.info.user_hash_sub = _.xor(this.info.user_hash_sub, [data.user.user_hash])
    },
    changeUserHashShare (cs) {
      this.info.user_hash_share = _.xor(this.info.user_hash_share, [cs.calendar_user])
    },
    changeUserHashShareSelf (data) {
      this.info.user_hash_share = _.xor(this.info.user_hash_share, [this.user.userHash])
    },
    changeUserHashShareFromNo (data) {
      this.info.user_hash_share = _.xor(this.info.user_hash_share, [data.user.user_hash])
    },
    uploadGoogleCalendarAttachmentFile (attachments, eventData) {
      if (this.filecnt == attachments.length && !this.errFlag) {
        let eventInfo = {
          attachments: attachments,
          event_data: eventData
        }
        this.$store.dispatch('calendar/updateGoogleCalendarAttachmentFile', eventInfo)
      } else if (this.filecnt == attachments.length && this.errFlag) {
        alert('GoogleDriveへのファイルアップロードが失敗したのでもう一度お願いします')
      }
    },
    changeRepeatDate(value) {
      if (value) {
        this.repeatMinDate = new Date(this.info.start)
        this.repeatMaxDate = this.setRepeatDate(this.info.start, 3);
        this.repeatEndDate = this.setRepeatDate(this.info.start, 1);
      }
    },
    changeRepeatInterval() {
      if (this.repeatInterval == 'week') {
        const weekDay = new Date(this.info.start).getDay();
        const daysMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        this.repeatWeekDay = [daysMap[weekDay]];
      } else {
        this.repeatWeekDay = []
      }
    },
    setRepeatDate(date, month) {
      let newDate = new Date(date)
      newDate.setMonth(date.getMonth() + month);
      if (newDate.getDate() !== date.getDate()) {
        newDate = new Date(date.getFullYear(), date.getMonth() + month + 1, 0);
      }
      newDate.setDate(newDate.getDate() - 1);
      return newDate
    },
    getDateCount() {
      let currentStartDate = new Date(this.info.start.valueOf())
      let repeatEndDate = new Date(this.info.repeat_end.valueOf())
      repeatEndDate.setHours(23)
      repeatEndDate.setMinutes(59)
      repeatEndDate.setSeconds(59)
      let count = 1
      while (currentStartDate <= repeatEndDate) {
        if (
          (
            this.info.repeat_interval === 'week' &&
            this.info.repeat_week.includes(currentStartDate.toLocaleString('en-us', { weekday: 'short' })) || 
            this.info.repeat_interval === 'day'
          ) && currentStartDate.toDateString() !== this.info.start.toDateString()
        ) {
          count += 1;
        }
        currentStartDate.setDate(currentStartDate.getDate() + 1);
      }
      return count
    }
  }
}
</script>

<style lang='scss' scoped>
.card-header {
  display: flex;
}
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.img-icon {
  display:    block;
  min-width:  200px;
  min-height: 200px;
  width:      200px;
  height:     200px;
  max-width:  200px;
  max-height: 200px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
}
.img-icon-sq {
  display:    block;
  min-width:  300px;
  min-height: 250px;
  width:      300px;
  height:     250px;
  max-width:  300px;
  max-height: 250px;
  border-radius: 5px;
  object-fit: cover;
  border: solid thin #ccc;
}
.btn-default-color{
  background: #f8f8f8;
}
.on_switch {
  background: #EE2C98;
  color: #ffffff;
}
.message {
  background: white;
}
.message::-webkit-scrollbar {
    width: 10px;
    height: 0px;
    visibility: hidden;
}
.tab-box {
  background: white;
  border: solid thin #ccc;
  border-radius: 8px;
  height: 400px;
  padding: 16px;
  margin-top: 16px;
}
.tab-box-form {
  width: 100%; display: flex; padding: 8px;
}
.tab-box-left {
  width: 30%; display: flex; justify-content: flex-start; align-items: center;
}
.tab-box-right {
  width: 70%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
/* Image Upload UI */
.upload-form {
  position: relative;
}
.upload-style {
  width: 100px;
  border-radius: 10px;
  text-decoration: none;
}
.upload-style > input {
  display: none;
}
.button-img {
  width: 300px;
  text-decoration: none !important;
}
.select_container {
  height: 272px;
  overflow: auto;
  border: 1px solid #dbdbdb;
  margin-bottom: 6px;
  border-radius: 3px;
}
.select_container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.description {
  font-size: 14px;
}
.select_list {
  margin: 16px 0 16px 32px;
  display: flex;
  align-items: center;
}
.patern_num {
  font-size: 14px;
  font-weight: bold;
  margin-right: 16px;
}
.ConnectingWord {
  font-size: 14px;
  margin: 6px;
}
.input_point {
  width: 64px;
}
.if_select {
  margin: 16px;
}
.close-wrapper {
  cursor: pointer;
  font-weight: bold;
  opacity: 0.6;
  margin-left: 16px;
  &:hover {
    opacity: 1;
    color: red;
  }
  .mdi-close {
    &:before {
      font-weight: bold;
    }
  }
}
.checkbox-item-container {
  font-size: 14px;
  padding:10px;
  padding-left:20px;
  &.-wrapper {
    align-items: center;
  }
}
.checkbox-index {
  margin-right: 8px;
}

/* ポイント入力の際勝手に動くバグがあるため、手動入力に変更 */
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance:textfield;
}
input::-ms-clear {
  visibility:hidden
}

.quote-list {
  height: 240px;
  position: absolute;
  right: 8px;
  top: 64px;
  width: 560px;
  border-radius: 5px;
  text-align: left;
  background-color: #ffffff;
  box-shadow: 0 0 3px grey;
  z-index: 10;
  overflow: auto;
  .list-title {
    font-weight: bold;
    margin-bottom: 8px;
  }
}
.quote-list-wrapper {
  overflow-y: scroll;
  margin: 8px;
}
.quote-list-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;

}
.open-quote-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.open-quote-btn {
  cursor: pointer;
}
.quote-list-content {
  table {
    margin: auto;
    font-size: 12px;
  }
  table th {
    padding: 4px;
  }
  table td {
    padding: 4px;
  }
}
.table-container {
  overflow-y: scroll;
}
.table-container::-webkit-scrollbar {
  width: 10px;
  height: 0px;
  visibility: hidden;
}
table thead th {
  top: 0;
  z-index: 1;
  background: #ffffff;
  border: 1px solid #000000;
}
.not-find-quote {
  font-size: 12px;
}
.quote-explain {
  font-size: 12px;
  margin-bottom: 16px;
}
.close-btn {
  cursor: pointer;
}
.upload-section {
  padding: 20px; color: black; background: #f2f2f2;
}
.not-create {
  opacity: 0.3;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalCreateEvent.vue